<template>
    <heads>
        <div class="grid grid-cols-2 gap-4">
            <div class="p-6 bg-white border-b border-gray-200 overflow-y-scroll h-screen-80 shadow-sm sm:rounded-lg">
                <p class="text-lg font-medium mb-4">List Roles</p>
                <breeze-table :fields="fields" :items="roles"
                              :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Role')"
                              :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Role')">
                    <template #action="data">
                        <button-link
                            v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Role')"
                            :href="route('heads.role.edit',data.item.id)">Edit
                        </button-link>
                    </template>
                </breeze-table>
            </div>
            <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
                <loading :showLoading="form.processing"/>
                <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                    <p class="text-lg font-medium mb-4">Add Role</p>
                    <form @submit.prevent="submitForm"
                          v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Role')">
                        <div class="grid grid-cols-8 gap-4 mb-8">
                            <div class="col-span-8 sm:col-span-8">
                                <breeze-label :required="true" :value="'Name'"/>
                                <breeze-input required v-model="form.name" class="w-full"/>
                                <breeze-input-error :message="form.errors?form.errors.name:''"/>
                            </div>
                            <div class="col-span-8 sm:col-span-8">
                                <breeze-label :required="true" :value="'Level'"/>
                                <breeze-input type="number" required v-model="form.level" class="w-full"/>
                                <breeze-input-error :message="form.errors?form.errors.level:''"/>
                            </div>
                        </div>
                        <breeze-button :disabled="form.processing">Submit</breeze-button>
                        <span v-if="form.recentlySuccessful" class="text-green-500 mx-4">Role Added!</span>
                        <exception/>
                    </form>
                    <div class="flex justify-center" v-else>
                        You have no permissions
                    </div>
                </div>
            </div>
        </div>
    </heads>
</template>

<script>
import Heads from '@/Pages/Heads/Heads'
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import ButtonLink from '@/Components/ButtonLink'
import CardHeader from '@/Components/CardHeader'
import {useForm} from '@inertiajs/inertia-vue3'
import BreezeInputError from '@/Components/InputError'
import BreezeButton from '@/Components/Button'
import BreezeCheckbox from '@/Components/Checkbox'
import Loading from '@/Components/Loading'
import Exception from '@/Components/Exception'
import BreezeTable from '@/Components/Table'

export default {
    components: {
        Heads,
        BreezeInput,
        BreezeLabel,
        ButtonLink,
        CardHeader,
        BreezeInputError,
        BreezeButton,
        BreezeCheckbox,
        Loading,
        Exception,
        BreezeTable
    },
    props: ['roles'],
    data() {
        return {
            form: useForm({
                name: '',
                level: '',
            }),
            fields: [
                {'key': 'name', 'label': 'Name'},
                {'key': 'level', 'label': 'Level'},
                {'key': 'action', 'label': 'Action'}
            ]
        }
    },
    methods: {
        submitForm() {
            this.form.post(route('heads.role.store'), {
                preserveScroll: true,
                onSuccess: () => {
                    this.form.reset();
                    location.reload()
                },
            });
        }
    }
}
</script>
